import visitService from "../api/services/visitService";
import { EU_COUNTRIES } from "@/utils/variables";
import { Visit } from "@/interfaces/Visit";
import { defineStore } from "pinia";

interface VisitState {
  visit: Visit | null;
  trackVisitPromise: Promise<void> | null;
}

export const useVisitStore = defineStore("visit", {
  state: (): VisitState => ({
    visit: null,
    trackVisitPromise: null,
  }),

  getters: {
    getVisit: (state: VisitState) => state.visit,
    isEUCountry: (state: VisitState) => EU_COUNTRIES.includes(state.visit?.country.toUpperCase() ?? ""),
  },

  actions: {
    async trackVisit(lang?: "en" | "de" | "fr") {
      this.visit = await visitService.trackVisit(lang);
    },
  },
});
